import { Engine } from "@babylonjs/core";
import { App } from "./App";
import { MainMenu } from "./scenes/MainMenu";

const canvas = document.getElementById("render-canvas");
if (!(canvas instanceof HTMLCanvasElement)) {
  throw new Error("#render-canvas not found");
}

const engine = new Engine(canvas, true, {
  preserveDrawingBuffer: true,
  stencil: true,
});

const app = new App(engine, canvas);
app.switchTo(new MainMenu(app));

window.addEventListener("resize", () => {
  engine.resize();
});
